<template>
    <Card :bordered="false" class="border-radius-0">
        <CTable
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            :searchFirst="false"
            @search="search => onSearch({ props, state, ...search })"
        >
            <template v-slot:afterSearch>
                <Descriptions v-if="state.refHaz" class="mt-2" layout="vertical" bordered :column="5" size="small">
                    <DescriptionsItem label="">{{ $t("views.stockCard.quotaQty") }}</DescriptionsItem>
                    <DescriptionsItem :label="$t('views.stockCard.reserve')"
                        ><Number :text="state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense?.quantityReserve || 0" :allowPrecision="true"></Number
                    ></DescriptionsItem>
                    <DescriptionsItem :label="$t('views.stockCard.use')"
                        ><Number :text="state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense?.quantityUse || 0" :allowPrecision="true"></Number
                    ></DescriptionsItem>
                    <DescriptionsItem :label="$t('views.stockCard.balance')">
                        <Number
                            :text="
                                (state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense?.quantity || 0) -
                                    (state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense?.quantityReserve || 0) -
                                    (state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense?.quantityUse || 0) || 0
                            "
                            :allowPrecision="true"
                        ></Number
                    ></DescriptionsItem>
                    <DescriptionsItem :label="$t('model.hazLicense.quantity')">
                        <Number :text="state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense?.quantity || 0" :allowPrecision="true"></Number>
                    </DescriptionsItem>
                </Descriptions>
            </template>
        </CTable>
    </Card>
</template>

<script>
import { Card, Descriptions } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { initState, isLoading, onSearch } from "./stock-card.logic";

export default defineComponent({
    components: {
        Card,
        CTable: defineAsyncComponent(() => import("../../../../components/table/CTable")),
        Descriptions,
        DescriptionsItem: Descriptions.Item,
        Number: defineAsyncComponent(() => import("../../../../components/table/custom-render/Number"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "stock-cards" },
    },
    setup(props) {
        const state = reactive(initState({ props }));
        return { props, isLoading, state, onSearch };
    }
});
</script>
